// extracted by mini-css-extract-plugin
export default {"link":"BurgerMenu_link__lspTx","mobileNavActive":"BurgerMenu_mobileNavActive__IxJLk","mobileNav":"BurgerMenu_mobileNav__b9phv"};